import clsx from 'clsx';
import type { ClassValue } from 'clsx';

export const cn = (...args: ClassValue[]) => clsx(...args);
